var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('px-solicitacao-resposta-frete-lista',{attrs:{"solicitacoes":_vm.solicitacoes,"loading":_vm.loading,"on-change-options":_vm.onChangeOptions,"cotacao-id":_vm.cotacaoId,"options-list":_vm.optionsList},on:{"update":_vm.refresh}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }